import { render, staticRenderFns } from "./cardMgtyw.vue?vue&type=template&id=1e88102d&scoped=true&"
import script from "./cardMgtyw.vue?vue&type=script&lang=js&"
export * from "./cardMgtyw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e88102d",
  null
  
)

export default component.exports